import React from 'react';
import { User } from '@core/generated/gql-types';
import {
  OnboardingProgress,
  CandidateDetails,
  PersonalInformation,
  VevoWorkEntitlement,
} from './components';

interface DetailsProps {
  worker: User;
}

const Details: React.FC<DetailsProps> = ({ worker }) => {
  return (
    <div className="space-y-6">
      <OnboardingProgress worker={worker} />
      <CandidateDetails worker={worker} />
      <PersonalInformation worker={worker} />
      <VevoWorkEntitlement worker={worker} />
    </div>
  );
};

export default Details;
